import React from 'react'

/**
 * Label/value row used for the dense "stamdata" lists on profile pages.
 * The label is set in muted ink, fixed-width on wide screens so values
 * align in a column; on narrow screens it stacks.
 */
interface DataRowProps {
  label: React.ReactNode
  children: React.ReactNode
  className?: string
  /** Tighter row (e.g. Stamdata under company profile). */
  compact?: boolean
}

const DataRow: React.FC<DataRowProps> = ({ label, children, className = '', compact = false }) => {
  const pad = compact ? 'py-1.5' : 'py-2'
  const gap = compact ? 'gap-2 sm:gap-4' : 'gap-1 sm:gap-4'
  const cols = compact ? 'sm:grid-cols-[16rem_1fr]' : 'sm:grid-cols-[12rem_1fr]'
  return (
    <div
      className={`grid grid-cols-1 ${cols} ${gap} ${pad} border-b border-rule last:border-b-0 text-sm ${className}`}
    >
      <dt className="text-ink-500 font-medium text-sm">
        {label}
      </dt>
      <dd className="text-ink min-w-0">{children}</dd>
    </div>
  )
}

export default DataRow
